import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lang-selector" }
const _hoisted_2 = { class: "lang" }
const _hoisted_3 = { class: "lang" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass([{ active: _ctx.currentLanguage('pl') }, "menu-link d-flex"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLang('pl')))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "fi fi-pl" }, null, -1)
        ]))], 2)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass([{ active: _ctx.currentLanguage('en') }, "menu-link d-flex"]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLang('en')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("span", { class: "fi fi-gb" }, null, -1)
        ]))], 2)
      ])
    ])
  ]))
}